export interface CohortSession {
  number: number;
  title: string;
  date: string;
  description: string;
}

export interface CohortPageData {
  slug: string;
  monthYearLabel: string;
  startDateLabel: string;
  startDateIso: string;
  timeLabel: string;
  weekdayLabel: string;
  seoDescription: string;
  ogImage: string;
  schedule: CohortSession[];
}

export const NEXT_COHORT: CohortPageData = {
  slug: "october-2026",
  monthYearLabel: "October 2026",
  startDateLabel: "October 1, 2026",
  startDateIso: "2026-10-01",
  timeLabel: "11 AM ET",
  weekdayLabel: "Thursdays",
  seoDescription:
    "Join the next live cohort on October 1, 2026. 5 live sessions over 5 weeks — build a working AI prototype for your HR workflow with expert guidance. Limited spots available.",
  ogImage: "/images/og-image-new.jpg",
  schedule: [
    {
      number: 1,
      title: "Understanding Your AI Readiness",
      date: "October 1, 2026",
      description:
        "The six forces that shape whether AI deployments stick — or stall.",
    },
    {
      number: 2,
      title: "Selecting a Use Case with Task-Tech Fit",
      date: "October 8, 2026",
      description:
        "Five practical filters for picking work where AI earns trust and ROI.",
    },
    {
      number: 3,
      title: "Creating an AI Assistant Proof-of-Concept",
      date: "October 15, 2026",
      description:
        "Define the job, constrain the behavior, test with real scenarios.",
    },
    {
      number: 4,
      title: "Preparing Knowledge for AI",
      date: "October 22, 2026",
      description:
        "Extract, clean, and structure what the model can use — so answers are useful.",
    },
    {
      number: 5,
      title: "Preparing to Scale",
      date: "October 29, 2026",
      description:
        "Turn a working demo into adoption with a concrete rollout plan.",
    },
  ],
};

export const LEGACY_COHORT_REDIRECTS = ["/may-2026"] as const;

export const NEXT_COHORT_PATH = `/${NEXT_COHORT.slug}`;
export const NEXT_COHORT_TITLE = `${NEXT_COHORT.monthYearLabel} Cohort`;
export const NEXT_COHORT_PAGE_TITLE = `${NEXT_COHORT.monthYearLabel} Cohort — AI for HR Mastermind`;
export const NEXT_COHORT_NAV_LABEL = `Next Cohort: ${NEXT_COHORT.startDateLabel}`;
export const NEXT_COHORT_HERO_CTA = `Learn About the ${NEXT_COHORT.monthYearLabel} Cohort`;
export const NEXT_COHORT_APPLY_CTA = `Apply for ${NEXT_COHORT.monthYearLabel} Cohort`;
export const NEXT_COHORT_TIME_LABEL = NEXT_COHORT.timeLabel;
export const NEXT_COHORT_MEMBERSHIP_LABEL = `${NEXT_COHORT.startDateLabel} @ ${NEXT_COHORT.timeLabel}`;
export const PREVIOUS_COHORT_STATUS = "May 21, 2026 cohort now in session";
export const EARLY_BIRD_DISCOUNT_CODE = "EARLY-BIRD-20";
export const EARLY_BIRD_DISCOUNT_LABEL =
  "Early-bird pricing: 20% off through August 18, 2026";
export const EARLY_BIRD_DISCOUNT_DETAIL = `${EARLY_BIRD_DISCOUNT_LABEL}. Code ${EARLY_BIRD_DISCOUNT_CODE}.`;

export const COHORT_DELIVERABLES = [
  "A working AI prototype purpose-built for your HR use case",
  "Task-technology fit assessment for your workflows",
  "Scaling action plan to amplify what your team does best",
  "Verified certificate of completion",
  "Access to a 200-member network of HR AI practitioners",
] as const;
